<template>
  <n-modal-background @close="$emit('close')" ref="bg">
    <n-modal-body width="l">
      <NTitleBar :title="$t('planSettings.buttons.talkToNotch')" closable @close="$refs.bg.close()" class="title" />
      <iframe src="https://calendly.com/callnotch/notch-discovery?embed_domain=www.notch.so&amp;embed_type=Inline" />
    </n-modal-body>
  </n-modal-background>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import NTitleBar from '@/modules/global/components/core/NTitleBar.vue'

@Component({
  components: { NTitleBar }
})
export default class TalkToSalesModal extends Vue {}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

.title {
  margin-top: $notch-space-8x;
  margin-left: $notch-space-8x;
  margin-right: $notch-space-8x;
}

iframe {
  height: $notch-space-190x;
  width: 100%;
  border: none;
  padding-bottom: $notch-space-10x;
  background-color: $notch-color-neutral-sand-50;
  border-top: $notch-space-05x solid $notch-color-neutral-sand-200;
}
</style>
